<script lang="ts">

	import type { SubShutter } from "../scripts/classes/page";

	export let inSubShutter: SubShutter;

	let isOpen: boolean = false;

	function toogleIsOpen() {
		isOpen = !isOpen;
	}

</script>

<style lang="scss">

	.subshutter {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border: 1px solid $color_black;
		border-radius: 48px;
		box-sizing: border-box;
		background-color: $color_grey;
		margin: 15px 0px 0px 0px;
		&__open {
			background: linear-gradient(
				to bottom,
				$color_grey 0,
				$color_grey 100px,
				$color_white 100px,
				$color_white 100%,
			);
		}
		&__header {
			padding: 16px 0 16px 0;
			width: 90%;
			display: flex;
			flex-direction: row;
			justify-content: center;
			align-items: center;
			&__left {
				width: 90%;
				display: flex;
				flex-direction: column;
				justify-content: space-around;
				align-items: flex-start;
				&__title {
					font-family: 'Borna-Bold';
					font-size: 13px;
					margin: 0 0 0 0;
				}
				&__text {
					font-family: 'Borna-Regular';
					font-size: 13px;
					color: #2F3031;
					opacity: 0.8;
				}
			}
			&__right {
				width: 10%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: flex-end;
				&__deploybtn {
					background-image: url('../assets/images/btn_plus.svg');
					width: 40px;
					height: 40px;
					&__open {
						background-image: url('../assets/images/btn_moins.svg');
					}
				}
			}
		}
		&__content {
			display: none;
			&__open {
				font-family: 'Borna-Medium';
				font-size: 13px;
				padding: 25px 0 25px 0;
				width: 90%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: flex-start;
				margin: 0 0 0 0;
				border-radius: 0 0 50px 50px;
				& :global(a) {
					text-decoration: none;
					color: $color_black;
					&::before {
						content: "↘";
						padding: 0 4px 0 0;
					}
					&:hover {
						text-decoration: underline;
					}
				}
				& :global(strong) {
					font-family: "Borna-Bold";
				}
			}
		}
	}

	@include large {
		.subshutter {
			border-radius: 58px;
			margin: 30px 0px 0px 0px;
			&:hover {
				background-color: $color_primary;
			}
			&__open {
				&:hover {
					background: linear-gradient(
						to bottom,
						$color_grey 0,
						$color_grey 100px,
						$color_white 100px,
						$color_white 100%,
					);
				}
			}
			&__header {
				cursor: pointer;
				padding: 25px 0 25px 0;
				&__left {
					&__title {
						font-size: 1.2vw;
						margin: 0 0 5px 0;
					}
					&__text {
						display: block;
						font-size: 1.2vw;
					}
				}
				&__right {
					&__deploybtn {
						width: 50px;
						height: 50px;
						&__open {
							background-image: url('../assets/images/btn_moins.svg');
							&:hover {
								background-image: url('../assets/images/btn_moins_hover.svg');
							}
						}
					}
				}
			}
			&__content {
				&__open {
					font-size: 1.2vw;
				}
			}
		}

	}

	@include xlarge {
		.subshutter {
			&__header {
				&__left {
					&__title {
						font-size: 16px;
					}
					&__text {
						font-size: 16px;
					}
				}
			}
			&__content {
				&__open {
					font-size: 16px;
				}
			}
		}

	}

</style>

<div class="subshutter" class:subshutter__open={isOpen}>
	<div class="subshutter__header" on:click={toogleIsOpen} on:keydown={toogleIsOpen}>
		<div class="subshutter__header__left">
			<div class="subshutter__header__left__title">{inSubShutter.title}</div>
			<div class="subshutter__header__left__text">{inSubShutter.subtitle}</div>	
		</div>
		<div class="subshutter__header__right">
			<div class="subshutter__header__right__deploybtn" class:subshutter__header__right__deploybtn__open={isOpen}></div>
		</div>
	</div>
	<div class="subshutter__content" class:subshutter__content__open={isOpen}>
		{@html inSubShutter.text}
	</div>
</div>
